import { FC, ReactNode } from "react";
import { Stack, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

interface StatsProps {
  number?: number;
  name?: string;
  icon?: ReactNode;
}

const Stats: FC<StatsProps> = ({
  number = 0,
  name = "stat",
  icon = <StarIcon sx={{ fontSize: "40px", color: "primary.main" }} />,
}) => {
  return (
    <Stack direction="column" justifyContent="center" alignItems="center">
      <Stack direction="row">
        <>
          {icon}
          <Typography variant="h5" component="div">
            {number}
          </Typography>
        </>
      </Stack>
      <Stack>
        <Typography align="center" sx={{ mb: 1.5 }} color="text.secondary">
          {name}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default Stats;
